// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
// import Axios from 'axios';
import Vue from 'vue';
import App from './App';
import router from './router';
import store from './store';
import VueClipboard from 'vue-clipboard2';
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css'
// import 'lib-flexible';
// import VideoPlayer from 'vue-video-player'
// Vue.use(VideoPlayer)
// require('vue-video-player/src/custom-theme.css')
// import fastClick from 'fastclick'
// fastClick.attach(document.body)
Vue.use(ElementUI);
Vue.use(VueClipboard);
Vue.config.ignoredElements.push('wx-open-launch-app')
// import * as google from 'vue2-google-maps'
import {
  Toast,
  Dialog,
  Image as VanImage,
  Button,
  Icon,
  Lazyload,
  NavBar,
  PullRefresh,
  Checkbox,
  CheckboxGroup
} from 'vant';
Vue.use(Lazyload);
import '@vant/touch-emulator';
import * as filters from './tools.js';
import promise from 'es6-promise';
promise.polyfill();
import 'lib-flexible';
import 'amfe-flexible/index.js';
Vue.use(PullRefresh);
Vue.use(VanImage);
Vue.use(Button);
Vue.use(Icon);
Vue.use(Checkbox);
Vue.use(Lazyload);
Vue.use(CheckboxGroup);
Vue.use(NavBar);
Vue.config.productionTip = false;
Vue.prototype.utils = filters;
Vue.prototype.dialog = Dialog;
Vue.prototype.toast = Toast;

// axios.defaults.retry = 4;//超時重新請求接口
// axios.defaults.retryDelay = 1000;

// axios.interceptors.response.use(undefined, function axiosRetryInterceptor(err) {
//     var config = err.config;
//     // If config does not exist or the retry option is not set, reject
//     if(!config || !config.retry) return Promise.reject(err);

//     // Set the variable for keeping track of the retry count
//     config.__retryCount = config.__retryCount || 0;

//     // Check if we've maxed out the total number of retries
//     if(config.__retryCount >= config.retry) {
//         // Reject with the error
//         return Promise.reject(err);
//     }

//     // Increase the retry count
//     config.__retryCount += 1;

//     // Create new promise to handle exponential backoff
//     var backoff = new Promise(function(resolve) {
//         setTimeout(function() {
//             resolve();
//         }, config.retryDelay || 1);
//     });

//     // Return the promise in which recalls axios to retry the request
//     return backoff.then(function() {
//         return axios(config);
//     });
// });
new Vue({
  el: '#app',
  router,
  store,
  components: {
    App
  },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js